import { render, staticRenderFns } from "./save-cancel-buttons.vue?vue&type=template&id=247b6b2d"
import script from "./save-cancel-buttons.vue?vue&type=script&lang=js"
export * from "./save-cancel-buttons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports